import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const { useState, useEffect } = require('react');

const useGetAllWH = () => {
  const [allWH, setAllWH] = useState([]);

  useEffect(() => {
    const fetchAllContracts = async () => {
      try {
        const activeResponse = await customAxios.get('/Ops/GetContracts?flagActive=1', {
          headers: authHeader(),
        });

        const onlyWH = Array.isArray(activeResponse?.data) ? activeResponse.data.map(item => item.contractUniqueID) : [];
        setAllWH(onlyWH);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAllContracts();
  }, []);

  return allWH;
};

export default useGetAllWH;
